import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  root: {
    height: 'auto',
  },
  imagePicker: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    border: '1px solid #ABAFB3',
    overflow: 'hidden',
  },
  active: {
    borderWidth: 2,
    borderColor: theme.palette.secondary.main,
  },
  fileInput: {
    display: 'none',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  bottomButton: {
    textTransform: 'none',
  },
  removeButtonText: {
    color: '#E02020',
  },
  changeImageLabel: {
    padding: '6px 8px',
    cursor: 'pointer',
  },
  changeImageText: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  addImage: {
    cursor: 'pointer',
    paddingLeft: theme.spacing(13)
  },
  title: {
    color: theme.palette.common.black,
    paddingRight: theme.spacing(5),
    fontSize: theme.spacing(9),
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: theme.spacing(6),
  },
}));
